module.exports = __webpack_public_path__ + "static/media/Stripe-Payment-Logo.eb05887e.png";